import clsx from 'clsx';
import React, { useState } from 'react';
import DrawerSkeleton from '../..';
import CommonCard from '../../../Components/General/CommonCard';
import LabeledText from '../../../Components/General/LabeledText';
import RenderServicePills from '../../../Components/General/RenderServicePills';
import Button from '../../../Components/UI/Button';
import { quickActions } from '../../../data';
import useAppointment from '../../../Features/useAppointment';
import usePatient from '../../../Features/usePatient';
import {
  appointmentDateRange,
  formatPhoneNumber,
  numberFormatter,
  transformServices
} from '../../../Helpers';
import AlertModal from '../../../Modals/AlertModal';
import CancelAppointmentModal from '../../../Modals/CancelAppointmentModal';
import DrawerHeader from '../../DrawerHeader';
import RescheduleAppointmentDrawer from '../../TodayAppointmentDrawer/RescheduleAppointment';
import classes from './PatientInformation.module.css';
const QuickAction = ({ title, icon, className, ...rest }) => {
  return (
    <CommonCard
      Tag="button"
      className={clsx(classes.quickCard, 'transparent-button', className)}
      {...rest}>
      {icon}
      <p className={classes.actionName}>{title}</p>
    </CommonCard>
  );
};
export default function PatientInformationDrawer({
  show,
  setShow,
  setShow2,
  data = [],
  selectedDate
}) {
  const [selectedAction, setSelectedAction] = useState(0);
  const [showRescheduleAppointmentDrawer, setShowRescheduleAppointmentDrawer] = useState(false);
  const [showConfirmMoveToQueueAlert, setShowConfirmMoveToQueueAlert] = useState(false);
  const [showCancelAppointmentModal, setShowCancelAppointmentModal] = useState(false);
  const toggleRescheduleDrawer = () => {
    setShowRescheduleAppointmentDrawer((prev) => !prev);
    setSelectedAction(-1);
  };
  const { getAllPatientsListing } = usePatient();
  const { moveToQueue, loading, cancelAppointment, getAllAppointments } = useAppointment();
  const decideDrawer = (action) => {
    if (action == 1) {
      setShowConfirmMoveToQueueAlert(true);
    } else if (action == 3) {
      setSelectedAction(-1);
      toggleRescheduleDrawer();
      setShow();
    } else if (action == 4) {
      setShowCancelAppointmentModal(true);
    }
  };
  const onToggle = () => {
    setShow();
    setSelectedAction(-1);
  };
  const sumOfServiceFee = data?.appointmentDetail?.reduce((acc, service) => {
    return acc + service?.netAmount;
  }, 0);
  let patientType = 'Appointment';

  if (data?.isDeleted) {
    patientType = 'Cancelled';
  } else if (data?.followUp) {
    patientType = 'Follow Up';
  }
  return (
    <>
      <DrawerSkeleton
        show={show}
        setShow={() => {
          onToggle();
        }}>
        <div className={clsx(classes.wrapper)}>
          <div className={classes.content}>
            <DrawerHeader
              title={'Patient Information'}
              setShow={onToggle}
              setShow2={() => {
                if (typeof setShow2 == 'function') {
                  setShow2();
                }
              }}
            />
            <section className={clsx(classes.listWrapper, 'scrollbar1')}>
              <CommonCard>
                <h3 className={classes.title}>{data?.patient?.patientName}</h3>
                <ul className={classes.generalInfo}>
                  <li>
                    <LabeledText
                      label={'Age/Gender:'}
                      value={`${data?.patient?.age}, ${data?.patient?.gender}`}
                    />
                    <LabeledText
                      label={'Phone Number'}
                      value={`${formatPhoneNumber(
                        data?.patient?.cellCountryCode + data?.patient?.cellNumber || ''
                      )}`}
                    />
                  </li>
                  <li>
                    <p
                      className={clsx(classes.type, {
                        [classes.cancelled]: data?.isDeleted,
                        [classes.followUp]: data?.followUp
                      })}>
                      {patientType}
                    </p>
                    <LabeledText
                      className={classes.alignFromRight}
                      label={'Service(s) Fee:'}
                      value={numberFormatter(sumOfServiceFee || '')}
                    />
                  </li>
                </ul>

                <div className={classes.bottomCtaWrapper}>
                  <h3>Service(s):</h3>
                  <div className={classes.servicesFieldWrapper}>
                    <RenderServicePills data={transformServices(data?.appointmentDetail)} />
                  </div>
                  {/* <ServicesPillWrapper services={allService} /> */}
                </div>

                {!data?.isDeleted && (
                  <menu className={classes.quickActionWrapper}>
                    {quickActions?.map((data) => (
                      <QuickAction
                        title={data?.title}
                        icon={data?.icon}
                        onClick={() => {
                          decideDrawer(data?.id);
                          setSelectedAction(data?.id);
                        }}
                        className={clsx({
                          [classes.quickActionPiece]: selectedAction == data?.id
                        })}
                      />
                    ))}
                  </menu>
                )}
              </CommonCard>
            </section>
            <div className={classes['cta-wrapper']}>
              <Button variants="secondary" label={'Close'} onClick={onToggle} />
            </div>
          </div>
        </div>
      </DrawerSkeleton>
      {showConfirmMoveToQueueAlert && (
        <AlertModal
          title={'Add To Queue'}
          onConfirm={() =>
            moveToQueue({ appointmentId: data?.appointmentId }, () => {
              setSelectedAction(-1);
            })
          }
          loading={loading}
          content={
            <span>
              Are you sure you want to add{' '}
              <span className={classes.highlightedName}>{data?.patient?.patientName}</span> in the
              queue
            </span>
          }
          show={showConfirmMoveToQueueAlert}
          setShow={setShowConfirmMoveToQueueAlert}
          onCancel={() => {
            setSelectedAction(-1);
          }}
        />
      )}
      <RescheduleAppointmentDrawer
        data={{
          ...data,
          patientId: data?.patient?.patientId,
          cellNumber: data?.patient?.cellNumber,
          countryCode: data?.patient?.cellCountryCode,
          age: data?.patient?.age,
          gender: data?.patient?.gender,
          patientName: data?.patient?.patientName
        }}
        show={showRescheduleAppointmentDrawer}
        setShow={() => {
          getAllPatientsListing(1, '');
          setSelectedAction(-1);
          toggleRescheduleDrawer();
        }}
        selectedDate={selectedDate}
        setShow2={setShow}
      />
      {showCancelAppointmentModal && (
        <CancelAppointmentModal
          onConfirm={() => {
            cancelAppointment(
              {
                appointmentId: data?.appointmentId,
                patientName: data?.patient?.patientName
              },
              () => {
                getAllPatientsListing(1, '');
                getAllAppointments(appointmentDateRange());
                setShowCancelAppointmentModal(false);
                setSelectedAction(-1);
                setShow();
              }
            );
          }}
          show={showCancelAppointmentModal}
          setShow={() => {
            setSelectedAction(-1);
            setShowCancelAppointmentModal(false);
          }}
          description={
            <p className={'description'}>
              Are you sure you want to cancel the appointment of{' '}
              <span className="highlighted">{data?.patient?.patientName}</span>
            </p>
          }
          onCancel={() => {
            setSelectedAction(-1);
          }}
        />
      )}
    </>
  );
}
